<template>
  <UIInputNumber
    ref="fieldRef"
    v-model="modelValue"
    :data-refid="dataRefid"
    :unformatted="isGridBunch"
    v-bind="{
      ...$attrs,
      disabled,
      error,
      label,
      silent,
      size,
    }"
  />
</template>

<script setup lang="ts">
import { computed, inject, ref, useTemplateRef } from 'vue'

import { InputSize, CashFlowProjectionClass } from '@types'

import { CASHFLOW_PROJECTION_FIELD } from '../utils/const'

import { UIInputNumber } from '@ui/fields'

type Props = {
  dataRefid?: string
  disabled?: boolean
  instance: CashFlowProjectionClass
  label?: string
  size?: InputSize
}

const props = defineProps<Props>()

defineExpose({
  focus() {
    fieldRef.value?.focus()
  },
})

const fieldRef = useTemplateRef<HTMLInputElement>('fieldRef')

const modelValue = props.instance.field<number>(CASHFLOW_PROJECTION_FIELD.VALUE)

const isSavedCashFlowProjection = inject('isSavedCashFlowProjection', ref(false))
const isGridBunch = inject<boolean>('isGridBunch', false)

const error = computed(() => props.instance.errors.value)
const silent = computed(() => !isSavedCashFlowProjection.value)
</script>
